import { render, staticRenderFns } from "./PopupPreview.vue?vue&type=template&id=ac512d7a&scoped=true"
import script from "./PopupPreview.vue?vue&type=script&lang=js"
export * from "./PopupPreview.vue?vue&type=script&lang=js"
import style0 from "./PopupPreview.vue?vue&type=style&index=0&id=ac512d7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac512d7a",
  null
  
)

export default component.exports